import { useRuntime } from '../internal';

export function useFetch(): typeof globalThis.fetch {
  return useRuntime().fetch;
}
